import React from "react";
import styles from "./experiencePage.component.less";
import aquavitaIMG from '../../../images/aquavita.png';
import aquavitaIMG2 from '../../../images/aquavita2.png';
import idevappIMG from '../../../images/idevapp.png';
import idevappIMG2 from '../../../images/idevapp2.png';

function ExperiencePage(props)
{
  let images = {
    "idevapp":[<img src={idevappIMG} alt="" />, <img src={idevappIMG2} alt="" />],
    "aquavita":[<img src={aquavitaIMG} alt="" />, <img src={aquavitaIMG2} alt="" />],
    "agency":[]
  };

  let content = props.data.map(x=>{
    return <>
      <div className={styles.experienceText}>
            <div>
              <h3>{x.company}</h3> <span className={styles.workingDate}> {x.yearStart} – {(x.yearEnd == 0 ? 'until now' : `${x.yearEnd}  (${(x.yearEnd-x.yearStart)} years)`)} </span>
            </div>
            <p>
                <p>
                <b>Position:</b> {x.position} <br /> 
                </p>
                <p>
                <b>Company:</b> {x.companyNameDetailed} <br /> 
                </p>
               
                  { 
                    
                        x.project && <>
                        <p>
                        <b>Project:</b> 
                        <span dangerouslySetInnerHTML={{__html: x.project}}></span>
                      </p>

                      </>
                    
                  }
                
                {
                  <p>
                     {
                      x.roleInProject &&
                      <>
                        <b>Project Role: </b>
                        {x.roleInProject}
                      </>
                     }
                  </p>
                }
                   
                    {
                      x.tasksPerformed && <>
                      <p>
                      <b> Tasks performed:</b> <br /> 
                      {x.tasksPerformed.map(line => (<div>{line}</div>))}
                      </p>
                      </>
                  }
               
                
                <p>
                  {x.environmentList && <>
                    <b>Environment:</b>
                    {x.environmentList}
                  </>}
                </p>
            </p>
        </div>
        <div>
            {images[x.key]}
        </div>
    </>;
  });

    return (
      <div id={styles.experience}>
        {content}  
      </div>
    );
}


export default ExperiencePage;